export enum SearchGroupTitles {
  Admin = 'Admin',
  Careers = 'Careers',
  Companies = 'Companies',
  Education = 'Education',
  Locations = 'Locations',
  People = 'People',
  Skills = 'Skills',
}
